import { useNavigate } from "react-router-dom";

export const useNavigateToModule = (id: string) => {
  const navigate = useNavigate();

  const navigateToModule = () => {
    navigate(`/LearningHub/Modules/${id}`);
  }

  return navigateToModule;
}
